export const cleanName = (name?: string) => (name ?? "").replace("_", " ");

export const styleStat = (n?: number) => {
  if (n === undefined) return "";
  const prefix = Math.sign(n) === 1 ? "+" : "";
  return `${prefix}${n}`;
};

const styleInfinity = (n: number) => (n === Infinity ? "∞" : n);

export const stylePlayerStat = ([value, max]: [number, number]) =>
  `${styleInfinity(value)}/${styleInfinity(max)}`;

export const styleCoinStat = ([value]: [number, number]) => `${value}`;
